import CustomerModule from "../Modules/Customer/CustomerModule";
import {Route, Redirect} from 'react-router-dom';
import { CustomerProvider } from "../Modules/Customer/CustomerContext";
import Logout from './Logout'
import useToken from './useToken';
import BundlesModule from "Modules/Bundles";
import SettingsModule from "Modules/Settings";
import { isSuperAdmin } from "utils";
import CustomerSubscriptionModule from "Modules/CustomerSubscription/CustomerSubscriptionModule";


function MainPanel() {
    const { token } = useToken();
    const isSAdmin = isSuperAdmin(token);

    return (
        <div className="MainPanel MainPanel--wrapper">
                <Route exact path="/" render={() => { console.log('mmain panel redirect'); return token ? (<Redirect to="/customer" />) : null}} />
                <Route path={`/logout`}>
                    <Logout/>
                </Route>

                <Route path={`/customer/:customerId?`}>
                    <CustomerProvider>
                        <CustomerModule/>
                    </CustomerProvider>
                </Route>

                <Route exact path={`/subscription`}>
                    <CustomerSubscriptionModule />
                </Route>
                <Route path={`/bundles`}>
                        <BundlesModule/>
                </Route>
                {isSAdmin && <Route path={`/settings`}>
                        <SettingsModule/>
                </Route>}
        </div>
    )
}

export default MainPanel;
